// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"821":"8e4d57fa","879":"0e8ed035"}[chunkId] + ".chunk.css";
};